// <pos-cart/> — 購物車 + 結帳入口
// see architecture.md#L510 (cart state machine)

import { cartStore, clearCart, removeFromCart, updateQty } from '../lib/state/cart.js';
import { escapeHtml } from '../lib/utils/escape.js';

class PosCart extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.unsub = cartStore.subscribe(() => this.render());
    this.render();
  }

  disconnectedCallback() {
    this.unsub?.();
  }

  render() {
    const items = cartStore.get();
    // 台灣餐飲慣例：菜單定價內含營業稅，結帳看到多少客人就付多少。
    const total = items.reduce((s, i) => s + i.price * i.qty, 0);

    this.shadowRoot.innerHTML = `
      <style>
        :host { display: flex; flex-direction: column; height: 100%; }
        .lines { flex: 1; overflow-y: auto; margin-bottom: var(--s-4); }
        .line {
          display: grid;
          grid-template-columns: 1fr auto auto;
          gap: var(--s-3);
          align-items: center;
          padding: var(--s-3) 0;
          border-bottom: 1px solid var(--border);
        }
        .line-name { font-size: 14px; }
        .line-qty button {
          min-width: 32px;
          min-height: 32px;
          background: var(--bg-surface);
          border: 1px solid var(--border);
          border-radius: var(--r-sm);
          margin: 0 4px;
        }
        .summary { padding: var(--s-3) 0; border-top: 1px solid var(--border-strong); }
        .summary-row { display: flex; justify-content: space-between; margin-bottom: var(--s-2); }
        .total { font-size: 20px; font-weight: 600; color: var(--brand-primary); }
        .checkout-btn {
          width: 100%;
          min-height: var(--touch-cta);
          margin-top: var(--s-4);
          background: var(--brand-primary);
          color: var(--fg-on-brand);
          border-radius: var(--r-md);
          font-size: 18px;
          font-weight: 600;
        }
        .empty { text-align: center; color: var(--fg-muted); padding: var(--s-10) 0; }
      </style>
      <h3>購物車 (${items.length})</h3>
      <div class="lines">
        ${items.length === 0 ? '<div class="empty">還沒點東西</div>' : items.map((item, idx) => `
          <div class="line" data-idx="${idx}">
            <div class="line-name">${escapeHtml(item.name)}<br/><small>NT$ ${escapeHtml(item.price)}</small></div>
            <div class="line-qty">
              <button data-act="dec" data-idx="${idx}">−</button>
              <span>${item.qty}</span>
              <button data-act="inc" data-idx="${idx}">+</button>
            </div>
            <button data-act="del" data-idx="${idx}">×</button>
          </div>
        `).join('')}
      </div>
      <div class="summary">
        <div class="summary-row total"><span>總計</span><span>NT$ ${total}</span></div>
      </div>
      <button class="checkout-btn" ${items.length === 0 ? 'disabled' : ''}>結帳</button>
    `;

    this.shadowRoot.querySelectorAll('[data-act]').forEach((el) => {
      el.addEventListener('click', () => {
        const idx = Number(el.dataset.idx);
        const act = el.dataset.act;
        if (act === 'inc') updateQty(idx, items[idx].qty + 1);
        else if (act === 'dec') updateQty(idx, items[idx].qty - 1);
        else if (act === 'del') removeFromCart(idx);
      });
    });

    this.shadowRoot.querySelector('.checkout-btn')?.addEventListener('click', () => {
      location.hash = '#/checkout';
    });
  }
}

customElements.define('pos-cart', PosCart);
